import '../node_modules/@vertem-core/vertice-ds/src/Assets/styles/style.css';
import '../node_modules/@vertem-core/vertice-ds/src/Assets/styles/Templates/Default/style.css';
import 'components/ds/assets/reset.css';

import React from 'react';
import { HashRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { VertTokensProvider } from '@vertem-core/vertice-ds';
import AppRoutes from './utils/Routes';
import { useTheme } from 'utils/ThemeService';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { GlobalStyles } from './GlobalStyle.styles';
import { OtpProvider } from './modules/account/context/OtpContextProvider';
import { ModulesProvider } from 'services/providers/ModulesProvider';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { ExistingIdentifiersProvider } from './modules/account/context/ExistingIdentifiersContext';
import ClarityAnalytics from './components/ClarityAnalytics';

const App: React.FC = () => {
  const {theme, isLoading} = useTheme();
  const queryClient = new QueryClient();
  
  const getTitle = () => {
    const theme = ApiLocalStorage.get('theme') || {};
    
    return theme?.header?.title || 'Programa'
  }
  
  const getFavicon = () => {
    const theme = ApiLocalStorage.get('theme') || {};
    
    return theme?.header?.favicon || ''
  }
  
  if (isLoading) {
    return <div></div>;
  }
  
  return (
    <>
      <ClarityAnalytics />
      <ModulesProvider>
        <ExistingIdentifiersProvider>
          <HelmetProvider>
            <Helmet>
              <title>
                {getTitle()}
              </title>
              <link rel="shortcut icon" href={getFavicon()}/>
              {
                theme?.global?.styleImport && (
                  <link rel="stylesheet" href={theme?.global?.styleImport}/>
                )
              }
            </Helmet>
            <HashRouter>
              <AuthProvider>
                <QueryClientProvider client={queryClient}>
                  <OtpProvider>
                    <VertTokensProvider
                      initialTokens={{
                        ...theme?.token,
                        ...theme?.designTokens,
                        ...(theme?.components && {components: theme.components})
                      }}
                    >
                      <AppRoutes/>
                      <GlobalStyles theme={theme}/>
                    </VertTokensProvider>
                  </OtpProvider>
                </QueryClientProvider>
              </AuthProvider>
            </HashRouter>
          </HelmetProvider>
        </ExistingIdentifiersProvider>
      </ModulesProvider>
    </>
  );
};

export default App;
